import {
  Component,
  h,
  Prop,
  State,
  Watch,
  Event,
  EventEmitter,
  ComponentInterface
} from '@stencil/core';
import { ActivityMapRegion, emitClickTrackerEvent } from '../../../utils/utils';

export interface INavigationItem {
  url: string;
  title?: string;
  target: string;
  label: string;
}

@Component({
  tag: 'ds-footer-navigation',
  styleUrl: 'ds-footer-navigation.scss'
})
export class DsFooterNavigation implements ComponentInterface {
  @Prop() navigationItems: Array<INavigationItem>;
  @Prop() isShowCookieInFooter: boolean;

  @State() isShowCookie: boolean = true;

  @Event({ eventName: 'openCookiePreferences', composed: true }) openCookie: EventEmitter;

  @Watch('isShowCookieInFooter')
  setInitialCookieVisibility(newValue: boolean) {
    this.isShowCookie = newValue;
  }

  componentWillLoad(): void {
    this.setInitialCookieVisibility(this.isShowCookieInFooter);
    document.addEventListener('enableCookiePreferences', () => {
      this.isShowCookie = true;
    });
  }

  private handleCookiePreference(event: MouseEvent): void {
    event.preventDefault();
    this.openCookie.emit();
  }

  render() {
    return (
      <ul class='ds-footer-navigation'>
        {this.navigationItems.map(({ label, url, title, target }) => (
          <li class='ds-footer-navigation__item'>
            <a
              class='ds-footer-navigation__link'
              href={url}
              title={title}
              target={target}
              onClick={() => {
                emitClickTrackerEvent({
                  componentName: ActivityMapRegion.Footer,
                  title: label,
                  url: url
                });
              }}
            >
              {label}
            </a>
          </li>
        ))}
        {this.isShowCookie && (
          <li class='ds-footer-navigation__item'>
            <a
              class='ds-footer-navigation__link cookiePreference'
              href='#'
              onClick={(event) => {
                emitClickTrackerEvent({
                  componentName: ActivityMapRegion.Footer,
                  title: `Cookie Preferences`,
                  url: '#'
                });
                this.handleCookiePreference(event);
              }}
            >
              Cookie Preferences
            </a>
          </li>
        )}
      </ul>
    );
  }
}
